import { Controller } from '@hotwired/stimulus'

import tippy from 'tippy.js'

export default class extends Controller {
  static targets = [
    'source',
    'avatar'
  ]

  connect() {
    this.tippy = tippy(this.avatarTarget, {
      allowHTML: true,
      animation: 'rotate',
      trigger: 'click',
      interactive: true,
      appendTo: document.body,
      content: this.sourceTarget.innerHTML,
      placement: 'bottom-end'
    })
  }

  disconnect() {
    this.tippy.destroy()
  }
}
